import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getClient } from '../../../shared/api/clients.api'
import type { ClientOption } from '../components/ClientCombobox'

/**
 * Выбранный клиент формы «Новая заявка» целиком — для поля «Клиент» и для
 * помощника (менеджер клиента).
 *
 * Выбор в выпадашке, новый клиент из модалки и черновик кладут клиента сразу
 * (setPickedClient); клиента из ссылки ?clientId= дочитываем по id. Раньше имя
 * брали из первых 200 клиентов по алфавиту, и клиент за их пределами выглядел
 * невыбранным — его создавали заново (проверка Сергея 15.09.2026).
 */
export function useSelectedClient(clientId: string) {
  const [picked, setPickedClient] = useState<ClientOption | null>(null)
  const { data: fetched } = useQuery({
    queryKey: ['clients', 'option', clientId],
    queryFn: () => getClient(clientId),
    enabled: !!clientId && picked?.id !== clientId,
    staleTime: 60_000,
    retry: false,
  })
  const selectedClient: ClientOption | null = picked?.id === clientId ? picked : (fetched ?? null)
  return { selectedClient, setPickedClient }
}
